import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { PromotionDetails, BundleDetails } from '../bundle/bundle';

@Injectable({ providedIn: 'root' })
export class ProductCatalogApi {
  private readonly http = inject(HttpClient);

  private readonly BUNDLES_DETAILS_URL = `${environment.PRODUCT_CATALOG_URL}/public/api/bundles-sales-details`;
  private readonly PROMO_DETAILS_URL = (promoCode): string =>
    `${environment.PRODUCT_CATALOG_URL}/public/api/promotions/${promoCode}/description`;

  getPromoDetails(promoCode: string): Observable<PromotionDetails> {
    return this.http
      .get<PromotionDetails>(this.PROMO_DETAILS_URL(promoCode))
      .pipe(catchError((err) => throwError(err)));
  }

  getBundlesDetails(codes: string[]): Observable<BundleDetails[]> {
    return this.http.post<BundleDetails[]>(this.BUNDLES_DETAILS_URL, codes).pipe(
      catchError((err) => throwError(err)),
      map((result: BundleDetails[]) => this.addColorToProducts(result)),
    );
  }

  /**
   * this parameter musts be provided by the product catalog - temporary solution
   * @param bundleDetails
   * @private
   */
  private addColorToProducts(bundleDetails: BundleDetails[]): BundleDetails[] {
    return bundleDetails.map((bundle) => {
      if (
        bundle.commercialCode === 'MYESSENTIAL' ||
        bundle.commercialCode === 'PROESSENTIAL' ||
        bundle.commercialCode === 'PROESSENTIAL-FIXED' ||
        bundle.commercialCode === 'MYESSENTIAL-FIXED'
      ) {
        return { ...bundle, color: '#fdfafc', gradient: 'linear-gradient(90deg, #5D49D2 0%, #AC29BE 100%)' };
      }

      if (
        bundle.commercialCode === 'MYCOMFORT' ||
        bundle.commercialCode === 'PROCOMFORT' ||
        bundle.commercialCode === 'PROCOMFORT-FIXED' ||
        bundle.commercialCode === 'MYCOMFORT-FIXED'
      ) {
        return { ...bundle, color: '#fdfafc', gradient: 'linear-gradient(90deg, #AC29BE 0%, #0766EC 100%)' };
      }

      if (
        bundle.commercialCode === 'MYDYNAMIC' ||
        bundle.commercialCode === 'PRODYNAMIC' ||
        bundle.commercialCode === 'MYDYNAMIC-FIXED' ||
        bundle.commercialCode === 'PRODYNAMIC-FIXED'
      ) {
        return { ...bundle, color: '#fdfafc', gradient: 'linear-gradient(90deg, #0764DA 0%, #00ABE2 100%)' };
      }

      if (
        bundle.commercialCode === 'MYDRIVE' ||
        bundle.commercialCode === 'PRODRIVE' ||
        bundle.commercialCode === 'MYDRIVE-FIXED' ||
        bundle.commercialCode === 'PRODRIVE-FIXED'
      ) {
        return { ...bundle, color: '#fdfafc', gradient: 'linear-gradient(90deg, #00ABE2 0%, #27B99D 100%)' };
      }

      // TODO: refactor string checking
      if (bundle.electricityDynamicPricing) {
        return { ...bundle, color: '#FDFAF9', gradient: 'linear-gradient(270deg, #890100 0%, #602000 100%)' };
      }
      if (
        bundle.commercialCode === 'PIXEL' ||
        bundle.commercialCode === 'PIXEL-FIXED' ||
        bundle.commercialCode === 'PIXEL-PRO-FIXED' ||
        bundle.commercialCode === 'PIXEL PRO' ||
        bundle.commercialCode === 'PIXEL-PRO'
      ) {
        return { ...bundle, color: '#fdfafc', gradient: 'linear-gradient(270deg, #964B96 0%, #462882 100%)' };
      }
      if (
        bundle.commercialCode === 'PIXIE' ||
        bundle.commercialCode === 'PIXIE PRO' ||
        bundle.commercialCode === 'PIXIE-PRO'
      ) {
        return {
          ...bundle,
          color: '#fefdf3',
          gradient: 'linear-gradient(91.76deg, #DD5608 1.41%, #EF6801 48.2%, #FF9400 98.89%)',
        };
      }
      if (
        bundle.commercialCode === 'PIXEL NEXT' ||
        bundle.commercialCode === 'PIXEL-NEXT' ||
        bundle.commercialCode === 'PIXEL NEXT PRO' ||
        bundle.commercialCode === 'PIXEL-NEXT-PRO' ||
        bundle.commercialCode === 'PIXEL NEXT FIXED' ||
        bundle.commercialCode === 'PIXEL-NEXT-FIXED' ||
        bundle.commercialCode === 'PIXEL_NEXT FIXED' ||
        bundle.commercialCode === 'PIXEL-NEXT-PRO-FIXED' ||
        bundle.commercialCode === 'PIXEL BLUE' ||
        bundle.commercialCode === 'PIXEL-BLUE' ||
        bundle.commercialCode === 'PIXEL BLUE PRO' ||
        bundle.commercialCode === 'PIXEL-BLUE-PRO' ||
        bundle.commercialCode === 'PIXEL BLUE FIXED' ||
        bundle.commercialCode === 'PIXEL-BLUE-FIXED'
      ) {
        return { ...bundle, color: '#f3fcff', gradient: 'linear-gradient(271.31deg, #0185FF 1.59%, #005596 99.33%)' };
      }
      if (
        bundle.commercialCode === 'PIXEL EDRIVE' ||
        bundle.commercialCode === 'PIXEL-EDRIVE' ||
        bundle.commercialCode === 'PIXEL EDRIVE PRO' ||
        bundle.commercialCode === 'PIXEL-EDRIVE-PRO' ||
        bundle.commercialCode === 'PIXEL EDRIVE FIXED' ||
        bundle.commercialCode === 'PIXEL-EDRIVE-FIXED' ||
        bundle.commercialCode === 'EMOBILITY' ||
        bundle.commercialCode === 'EMOBILITY-FIXED'
      ) {
        return { ...bundle, color: '#F9FEFA', gradient: 'linear-gradient(270deg, #32D458 0%, #00955B 100%)' };
      }

      return bundle;
    });
  }
}
